export const styles = ({
    container: {
        display: 'flex',
        justifyContent: 'center'
    }
});
